import { render, staticRenderFns } from "./CredentialExchange.vue?vue&type=template&id=0a6c75e2&"
import script from "./CredentialExchange.vue?vue&type=script&lang=js&"
export * from "./CredentialExchange.vue?vue&type=script&lang=js&"
import style0 from "./CredentialExchange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports